import {Modal, Input, Button, Select} from "antd";
import React, {useState, useEffect} from "react";
import {useTranslation} from "react-i18next";
import {useFormik} from "formik";
import stores from "../../../store/stores";
import userService from "../../../services/userService";

export const UpdateZoneManagementModal = ({
    visibility,
    detail,
    onCancel,
    setRecallZoneManagement
}) => {
    const [loading, setLoading] = useState(false);
    const [bmUsers, setBmUsers] = useState([]);
    const [bmUsersLoading, setBmUsersLoading] = useState(false);
    const {t} = useTranslation(["common"]);

    const formik = useFormik({
        initialValues: {
            name: detail?.name || "",
            bmUserId: detail?.bmUser?._id || undefined
        },
        enableReinitialize: true,
        validate: values => {
            const errors = {};

            if (!values.name) {
                errors.name = "Bölge müdürlüğü adı zorunludur!";
            } else if (values.name.length < 2) {
                errors.name = "Bölge müdürlüğü adı en az 2 karakter olmalıdır!";
            }

            return errors;
        },
        onSubmit: async values => {
            setLoading(true);
            try {
                const params = {
                    id: detail._id,
                    name: values.name
                };

                if (values.bmUserId) {
                    params.bmUserId = values.bmUserId;
                }

                const result = await stores.operationOrganizationStore.updateZoneManagement(params);

                if (result) {
                    setRecallZoneManagement(prev => !prev);
                    formik.resetForm();
                    onCancel();
                }
            } catch (error) {
                console.error("Form submission failed:", error);
            } finally {
                setLoading(false);
            }
        }
    });

    // BM kullanıcılarını çek
    useEffect(() => {
        if (visibility) {
            fetchBmUsers();
        }
    }, [visibility]);

    const fetchBmUsers = async () => {
        setBmUsersLoading(true);
        try {
            const response = await userService.getUserList({
                skip: 0,
                limit: 1000,
                activity: "active",
                role: "bm",
                searchText: ""
            });

            if (response?.data?.rows) {
                setBmUsers(response.data.rows);
            }
        } catch (error) {
            console.error("BM kullanıcıları yüklenemedi:", error);
        } finally {
            setBmUsersLoading(false);
        }
    };

    const handleCancel = () => {
        formik.resetForm();
        onCancel();
    };

    if (!visibility) {
        return null;
    }

    return (
        <Modal
            title="Bölge Müdürlüğünü Düzenle"
            visible={visibility}
            onCancel={handleCancel}
            footer={[
                <Button key="cancel" onClick={handleCancel}>
                    İptal
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    loading={loading}
                    onClick={formik.handleSubmit}
                    disabled={!formik.isValid}
                >
                    Güncelle
                </Button>
            ]}
            width={500}
            destroyOnClose={true}
        >
            <form onSubmit={formik.handleSubmit} style={{marginTop: 20}}>
                <div style={{marginBottom: 16}}>
                    <label
                        style={{
                            display: "block",
                            marginBottom: 8,
                            fontSize: "14px",
                            fontWeight: 500
                        }}
                    >
                        Bölge Müdürlüğü Adı
                    </label>
                    <Input
                        name="name"
                        placeholder="Bölge müdürlüğü adını giriniz"
                        maxLength={100}
                        value={formik.values.name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        status={formik.touched.name && formik.errors.name ? "error" : ""}
                    />
                    {formik.touched.name && formik.errors.name && (
                        <div style={{color: "#ff4d4f", fontSize: "12px", marginTop: 4}}>
                            {formik.errors.name}
                        </div>
                    )}
                </div>

                <div style={{marginBottom: 16}}>
                    <label
                        style={{
                            display: "block",
                            marginBottom: 8,
                            fontSize: "14px",
                            fontWeight: 500
                        }}
                    >
                        Bölge Müdürü (Opsiyonel)
                    </label>
                    <Select
                        style={{width: "100%"}}
                        placeholder="Bölge müdürü seçiniz"
                        loading={bmUsersLoading}
                        allowClear
                        showSearch
                        filterOption={(input, option) =>
                            option?.props?.children?.toLowerCase()?.indexOf(input?.toLowerCase()) >=
                                0 ||
                            option?.props?.value?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0
                        }
                        value={formik.values.bmUserId}
                        onChange={value => formik.setFieldValue("bmUserId", value)}
                    >
                        {bmUsers.map(user => (
                            <Select.Option key={user._id} value={user._id}>
                                {user.fullName}
                            </Select.Option>
                        ))}
                    </Select>
                </div>
            </form>
        </Modal>
    );
};
